import React from "react";
import styled from "styled-components";

const StripParent = styled.div`
  width: 100%;
  height: 2px;
  background-color: #b4af9a;
`

export const Strip = () => {
  return(
    <StripParent/>
  )
}